export const createWorker = () =>
  new Worker(
    // @ts-ignore
    new URL('./events.flow.worker.ts', import.meta.url),
  );
